var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sapphire-video flex"},[_c('div',{staticClass:"sapphire-video__player sapphire-video__player--full"},[_c('video',{attrs:{"src":"/apppreview-saph.mp4","autoplay":"","muted":"","playsinline":"","loop":""},domProps:{"muted":true}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }